import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Box } from '@enechain/ecloud-designsystem'
import { DealPosition } from '@enechain/eposition-proto/bfftypes/v1/deal_pb'

type Props = {
  positionType: DealPosition
}
export const DealPositionBadge: React.FC<Props> = ({ positionType }) => {
  const { t } = useTranslation(['domain'])

  const isOffer = positionType === DealPosition.OFFER

  return (
    <Box
      width="fit-content"
      minWidth="20px"
      height="20px"
      paddingX="4px"
      color="Text.highEmphasisInverse"
      textAlign="center"
      borderRadius="radiiBase"
      backgroundColor={isOffer ? 'Object.offer' : 'Object.bid'}
      textStyle="headerSm"
    >
      {isOffer
        ? t('domain:shared.position.offer_short')
        : t('domain:shared.position.bid_short')}
    </Box>
  )
}
